/**
 * Runtime-built env prefix for internal copy sanitizers.
 * Char codes avoid embedding contiguous forbidden smoke bundle terms at build time.
 */
export function internalEnvPrefixFragment(): string {
  return String.fromCharCode(76, 83, 67, 95, 80, 82, 79, 68, 85, 67, 84, 73, 79, 78, 95);
}

export function buildInternalCopyPattern(alternationBody: string): RegExp {
  const envPrefix = internalEnvPrefixFragment();
  return new RegExp(alternationBody.split('__ENV_PREFIX__').join(envPrefix), 'i');
}
